import styled from 'styled-components';

export const LayoutOverlayStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 15;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgb(255 255 255 / 80%);
`;
